// @ts-nocheck
import { icon, node } from "~/util/dom";

export default class Resizer {
	constructor({
		container,
		elements,
		steps,
		reverse,
	}) {
		this._node = node("div", { className: "content-resizer" });
		this._cont = node("div");

		this._opts = {
			container,
			elements,
			reverse,
			anchorRange: 60,
		};

		this._steps = steps;
		this._realSteps = [];
		this._actualStep = 4;
		this._prevStep = 4;
		this._mousePosition = null;
		this._contWidth = 0;
		this._widthSteps = [];
		this._dragChange = false;
		this._dragging = false;
		this._dragStepStart = this._actualStep;

		this._build();
	}

	destroy() {
		this._cont.removeEventListener("click", this);
		this._cont.removeEventListener("pointerdown", this);
		Mapy.Util.clear(this._node);
	}

	get steps() {
		return this._steps;
	}

	get node() {
		return this._node;
	}

	get boarderLine() {
		this._countBoarderLine();

		return this._widthSteps.slice();
	}

	handleEvent(event) {
		if (event.type === "click") {
			if (!this._dragChange) {
				if (event.target === this._button || this._button.contains(event.target)) {
					if (this._actualStep === this._steps.length || this._actualStep === 1) {
						if (this._actualStep === this._steps.length) {
							this._actualStep--;
						} else if (this._actualStep === 1) {
							this._actualStep++;
						}

						this._widthChange();
						this._prevStep = this._actualStep;

						Mapy.getComponent("logger").log("ratio_change", Mapy.getComponent("gallery").logData);
					}
				}
			}
		} else if (event.type === "pointerdown") {
			this._mousePosition = {
				x: event.clientX,
				y: event.clientY,
			};

			this._countBoarderLine();

			this._cont.classList.add("active");

			this._dragStepStart = this._actualStep;

			document.addEventListener("pointermove", this);
			document.addEventListener("pointerup", this);
		} else if (event.type === "pointerup") {
			this._widthSteps = [];
			//this._realSteps = [];
			this._mousePosition = null;

			this._cont.classList.remove("active");

			document.removeEventListener("pointermove", this);
			document.removeEventListener("pointerup", this);

			this._opts.elements[0].style.width = "";
			this._opts.elements[1].style.width = "";

			this._dragEnd(this._actualStep);

			this._dragStepStart = this._actualStep;

			setTimeout(() => { // pokud doslo ke zmene, tak aby nenastal click
				this._dragChange = false;
			}, 300);
		} else if (event.type === "pointermove") {
			// eslint-disable-next-line id-length
			const x = event.clientX;
			let index = this._actualStep;

			this._dragStart(this._actualStep);

			this._opts.elements[this._opts.reverse ? 1 : 0].style.width = `${x}px`;
			this._opts.elements[this._opts.reverse ? 0 : 1].style.width = `${this._contWidth-x}px`;


			this._widthSteps.forEach((borderL, keyindex) => {
				if (x >= borderL) {
					index = keyindex + 1;
				}
			});

			if (this._mousePosition && Math.abs(this._mousePosition.x - x) > 6) {
				this._mousePosition = {
					x: event.clientX,
					y: event.clientY,
				};

				this._dragChange = true;
				this._drag(index, this._contWidth - this._realSteps[index-1] < x);
			}

			if (index !== this._actualStep) {
				this._actualStep = index;
				this._widthChange();
				this._prevStep = this._actualStep;
			}
		}
	}

	set(step) {
		this._actualStep = step > 0 && step <= this._steps.length ? step : this._actualStep;
		this._widthChange();
		this._prevStep = this._actualStep;
	}

	_build() {
		const button = node("button", { type: "button" });

		button.setAttribute("data-log-ignore", "1");
		button.appendChild(icon("resizer-arrow"));
		button.appendChild(icon("drag-handle"));

		this._cont.appendChild(button);

		this._cont.addEventListener("click", this);
		this._cont.addEventListener("pointerdown", this);

		this._node.appendChild(this._cont);

		this._button = button;
	}

	_countBoarderLine() {
		this._widthSteps = [];
		this._contWidth = this._opts.container.offsetWidth;

		this._realSteps = this._steps.map(step => {
			if ((typeof step).toLowerCase() === "string" && step.includes("%")) {
				return parseInt(step) ? Math.round(this._contWidth * parseInt(step) / 100) : 0;
			}

			return parseInt(step);
		});

		this._realSteps.forEach((cs, index) => {
			let step = this._opts.reverse ? this._contWidth - cs : cs;

			if (index !== 0) {
				step += (this._realSteps[index-1]-cs)/2*(this._opts.reverse ? -1 : 1);
			}

			this._widthSteps.push(step);
		});
	}

	_widthChange() {
		const event = new CustomEvent("width-change", { detail: { actual: this._actualStep, prev: this._prevStep } });

		this._node.dispatchEvent(event);
	}

	_dragStart(index) {
		if (!this._dragging) {
			this._dragging = true;
			const event = new CustomEvent("drag-start", { detail: { index } });

			this._node.dispatchEvent(event);
		}
	}

	_drag(index, biggest) {
		if (this._dragging) {
			const event = new CustomEvent("drag", { detail: { index, biggest } });

			this._node.dispatchEvent(event);
		}
	}

	_dragEnd(index) {
		if (this._dragging) {
			this._dragging = false;
			const event = new CustomEvent("drag-end", { detail: { index } });

			this._node.dispatchEvent(event);

			if (this._dragStepStart !== this._actualStep) {
				Mapy.getComponent("logger").log("ratio_change", Mapy.getComponent("gallery").logData);
			}
		}
	}
}
